/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Code_Of_Ethics_TitleInputs */



/**
* | output |
* | --- |
* | "Code of Ethics" |
*
* @param {Help_Code_Of_Ethics_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_code_of_ethics_title = /** @type {((inputs?: Help_Code_Of_Ethics_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Code_Of_Ethics_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code d'éthique")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código ético")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Código de ética")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice etico")
	return /** @type {LocalizedString} */ ("Code of Ethics")
});